<!-- 站点超管-角色菜单管理 -->
<template>
  <scroll-right-frame>
    <div class="site-role-menu" style="padding: 0 10px 10px 10px;">
      <div style="margin: 8px;height: 36px; line-height: 36px;">
        <el-select
          size="small"
          v-model="selectRole"
          placeholder="请选择角色"
          @change="onSelectRoleChange"
        >
          <el-option
            v-for="role in roles"
            :key="role.id"
            :label="role.name"
            :value="role.id">
          </el-option>
        </el-select>

        <el-button
          v-if="selectRole"
          size="small"
          @click="saveRoleMenuConfig"
        >保存</el-button>
      </div>

      <div style="border: 1px solid #dcdfe6;">
        <el-tree
          v-if="selectRole"
          ref="myTree"
          :data="treeData"
          :props="defaultProps"
          :empty-text="message"
          show-checkbox
          node-key="id"
          :expand-on-click-node="false"
          :default-expanded-keys="['root']"
          @check="onTreeNodeCheck"
        >
          <span
            class="custom-tree-node"
            slot-scope="{ node, data }">
            <span class="tree-node-label">{{ node.label }}</span>
            <!--集成菜单-->
            <div class="integrated-menu-box">
              <el-checkbox-group v-model="gridMenuIds">
                <el-checkbox v-for="sMenu in data.integratedMenuList" :key="sMenu.gridMenuId" :label="sMenu.gridMenuId">{{ sMenu.gridMenuName }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <!--自定义菜单-->
            <div class="custom-menu-box">
              <el-checkbox-group v-model="gridMenuIds">
                <el-checkbox v-for="sMenu in data.customMenuList" :key="sMenu.gridMenuId" :label="sMenu.gridMenuId">{{ sMenu.gridMenuName }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </span>
        </el-tree>
      </div>
    </div>
  </scroll-right-frame>
</template>

<script>
  import util from '../../libs/util'
  import ScrollRightFrame from '../../components/scroll-right-frame.vue'

  export default {
    components: {
      ScrollRightFrame
    },
    name: 'site_role_menu',
    data() {
      return {
        loading: false,
        selectRole: '',
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        roles: [],
        gridMenuIds: []
      }
    },
    computed: {
      message: function () {
        if (!this.selectRole) {
          return '请先选择角色'
        } else {
          return ''
        }
      }
    },
    created() {
      this.initRole()
    },
    methods: {
      initRole() { // 初始化站点角色
        this.selectRole = ''
        this.loadRoles()
      },
      loadRoles() { // 加载角色列表
        util.ajax.post('/siteAdmin/sitePermissionManage/getAllRoles').then((res) => {
          if (res.data.meta.errCode === 0) {
            this.roles = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取角色数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取角色数据失败'})
          console.error(err)
        })
      },
      onSelectRoleChange() { // 选择角色后加载角色的菜单树
        this.loadTreeData()
      },
      loadTreeData() { // 加载角色菜单树
        let params = {roleId: this.selectRole}
        util.ajax.post('/siteAdmin/sitePermissionManage/menu/treeWithSubMenu', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.treeData = [{
              id: 'root',
              name: '功能列表',
              children: res.data.data,
              isLeaf: '0'
            }]
            this.loadRoleMenusAndGridMenus()
          } else {
            this.$notify.info({title: '提示', message: '获取菜单数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取菜单数据失败：'})
          console.error(err)
        })
      },
      loadRoleMenusAndGridMenus() {
        let params = {roleId: this.selectRole}
        util.ajax.post('/siteAdmin/sitePermissionManage/getRoleMenuIds', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$refs.myTree.setCheckedKeys(res.data.data)
          } else {
            this.$notify.info({title: '提示', message: '获取数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取数据失败'})
          console.error(err)
        })
        util.ajax.post('/siteAdmin/sitePermissionManage/getRoleGridMenuIds', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.gridMenuIds = res.data.data
          } else {
            this.$notify.info({title: '提示', message: '获取数据失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '获取数据失败'})
          console.error(err)
        })
      },
      saveRoleMenuConfig() { // 保存角色菜单配置
        if (!this.selectRole) {
          this.$notify.info({title: '提示', message: '请选择角色'})
        }
        let menuIds = this.$refs.myTree.getCheckedKeys()
        // 删除虚拟的根节点
        for (let i = menuIds.length - 1; i >= 0; i--) {
          if (menuIds[i] === 'root') {
            menuIds.splice(i, 1)
          }
        }
        let params = {roleId: this.selectRole, menuIds: menuIds, gridMenuIds: this.gridMenuIds}
        util.ajax.post('/siteAdmin/sitePermissionManage/saveRoleMenuIds', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '保存成功'})
          } else {
            this.$notify.info({title: '提示', message: '保存失败：' + res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '错误：'})
          console.error(err)
        })
      },
      onTreeNodeCheck(data, obj) {
        // 判断是否check
        let nodeIsChecked = false
        if (obj.checkedKeys && obj.checkedKeys.length > 0) {
          for (let i = 0; i < obj.checkedKeys.length; i++) {
            if (obj.checkedKeys[i] === data.id) {
              nodeIsChecked = true
              break
            }
          }
        }
        let nodeMenuIds = []
        if (data.integratedMenuList && data.integratedMenuList.length > 0) {
          for (let j = 0; j < data.integratedMenuList.length; j++) {
            nodeMenuIds.push(data.integratedMenuList[j].gridMenuId)
          }
        }
        if (data.customMenuList && data.customMenuList.length > 0) {
          for (let j = 0; j < data.customMenuList.length; j++) {
            nodeMenuIds.push(data.customMenuList[j].gridMenuId)
          }
        }
        if (data.children && data.children.length > 0) {
          for (let i = 0; i < data.children.length; i++) {
            this.onTreeNodeCheck(data.children[i], obj)
          }
        }
        if (nodeIsChecked) {
          util.pushAll(this.gridMenuIds, nodeMenuIds)
        } else {
          util.removeAll(this.gridMenuIds, nodeMenuIds)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/site-admin/menu-manage/site_role_menu.vue